import { useState, useCallback } from 'react'

export interface RemoveGroupMemberModalData {
  groupId: string
  memberId: string
  memberName: string
  groupName: string
}

export interface UseRemoveGroupMemberModalProps {
  onSuccess?: () => void
}

export function useRemoveGroupMemberModal({ onSuccess }: UseRemoveGroupMemberModalProps = {}) {
  const [modalData, setModalData] = useState<RemoveGroupMemberModalData | null>(null)

  const openModal = useCallback((data: RemoveGroupMemberModalData) => {
    setModalData(data)
  }, [])

  const closeModal = useCallback(() => {
    setModalData(null)
  }, [])

  return {
    isOpen: !!modalData,
    modalData,
    openModal,
    closeModal,
    onSuccess
  }
}
